import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { CostCenterPriceModel } from 'src/app/models/archive/cost-center-price.model';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { RemissionDetailModel } from 'src/app/models/rental/remission-detail';
import { RemissionDetailFromOrderModel } from 'src/app/models/rental/remission-detail-from-order.model';
import { RemissionModel } from 'src/app/models/rental/remission.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { MassiveOrderDetailSelectionTable } from 'src/app/models/tables/preliminaries/massive-order-detail-selection-table.model';
import { RemissionDetailRegisterModel } from 'src/app/models/tables/rental/remission-detail-register.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { RemissionDetailService } from 'src/app/services/rental/remission-detail.service';
import { RemissionFromOrderService } from 'src/app/services/rental/remission-from-order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RegisterCostCenterPriceComponent } from 'src/app/views/archive/cost-center-price/register-cost-center-price/register-cost-center-price.component';
import { ManualOrderComponent } from '../manual-order/manual-order.component';
import { MassiveOrderComponent } from '../massive-order/massive-order/massive-order.component';
import { RemissionDetailHoursDaysComponent } from '../remission-detail-hours-days/remission-detail-hours-days.component';

@Component({
  selector: 'app-remission-detail',
  templateUrl: './remission-detail.component.html',
  styleUrls: ['./remission-detail.component.scss'],
  standalone: false
})
export class RemissionDetailComponent implements OnInit {
  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('captureHoursDaysModal') captureHoursDaysComponent?: CustomModalComponent | null = null;
  @ViewChild('costCenterPriceRegisterModal') costCenterPriceRegisterComponent?: CustomModalComponent | null = null;
  @ViewChild('manualOrderSelection') manualOrderSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('massiveOrderSelection') massiveOrderSelectionModalComponent?: CustomModalComponent | null = null;

  @Input() disabledDetail: boolean = false;
  @Input() permissionsUser: OptionWindowModel[] = [];
  @Input() permissionUpdatable: boolean = false;
  @Input() quantityDetails: number = 0;
  @Input() remissionModel: RemissionModel = new RemissionModel();
  @Input() userAuthenticated: UserModel = new UserModel();
  @Output() emitQuantityDetails = new EventEmitter<number>();
  @Output() reloadRemissionContract = new EventEmitter<boolean>();

  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  breakpointsForHoursDays: { [key: string]: string } = {
    '1024px': '50vw',
    '768px': '60vw',
    '560px': '90vw'
  };
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  componentManualOrderSelection = ManualOrderComponent;
  componentMassiveOrderSelection = MassiveOrderComponent;
  componentRegisterModal = RegisterCostCenterPriceComponent;
  componentCaptureHoursDaysModal = RemissionDetailHoursDaysComponent;
  componentTableSelection = CustomTableSelectComponent
  costCenterPriceContract: CostCenterPriceModel = new CostCenterPriceModel();
  dataArticle: PagedResponseModel<RentalStockModel> = new PagedResponseModel<RentalStockModel>();
  detailData: PagedResponseModel<RemissionDetailRegisterModel> = new PagedResponseModel<RemissionDetailRegisterModel>();
  detailHeader: ColumnResponseModel[] = [];
  filtersArticle: ColumnResponseModel[] = [];
  formTitle: string = '';
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    actions: [],
    filters: [],
  });
  inputsForManualOrderSelectionModals$ = new BehaviorSubject<any>({
    remissionModel: new RemissionModel(),
  });
  inputsForCaptureHoursDaysModals$ = new BehaviorSubject<any>({
    remissionContract: new RemissionModel(),
    remissionDetailContract: new RemissionDetailModel(),
  });
  inputsForMassiveOrderSelectionModals$ = new BehaviorSubject<any>({
    remissionId: 0,
  });
  inputsForRegisterModals$ = new BehaviorSubject<any>({
    blockForm: false,
    costCenterPriceModel: new CostCenterPriceModel(),
    openFrom: ''
  });
  isFormOrderView: boolean = false;
  isFormView: boolean = false;
  limit: number = 10;
  limitArticle: number = 5;
  listObservers: Array<Subscription> = new Array<Subscription>();
  openFromCostCenterPrice: string = "";
  openModal: boolean = false;
  output$ = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  remissionDetail: RemissionDetailModel = new RemissionDetailModel();
  remissionDetailFromOrder: RemissionDetailFromOrderModel = new RemissionDetailFromOrderModel()
  subscription: Subscription;
  swDispatchEnabled: boolean = false;
  swOrderModule: boolean = false;
  swReservation: boolean = false;
  swMaintenanceScheduling: boolean = false;
  tableActions: TableAction[] = [];

  constructor(private remissionDetailService: RemissionDetailService,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private remissionFromOrderService: RemissionFromOrderService,
    private confirmDialogService: ConfirmDialogService,
  ) {
    this.getGeneralParametersByCompany();
  }

  async ngOnInit() {
    this.updateFormTitle();
    await this.getColumns();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        case 'onReload':
          this.getRemissionDetailsByRemission();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const remissionModel = changes["remissionModel"];
    if (remissionModel && !remissionModel.firstChange) {
      this.clearSelectionTrigger++;
      this.getFormView(false);
      this.getFormOrderView(false);
      this.getRemissionDetailsByRemission();
      this.remissionDetail = new RemissionDetailModel();
      this.remissionDetailFromOrder = new RemissionDetailFromOrderModel();
    }

    const disabledDetail = changes["disabledDetail"];
    if (disabledDetail) {
      this.changeDisabled(disabledDetail.currentValue);
    }
  }

  ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
    this.subscription?.unsubscribe();
  }

  changeDisabled(disabled: boolean) {
    if (disabled) {
      const actions = [{
        label: 'Editar Precios C.Costos',
        icon: 'pi pi-dollar',
        action: 'prices-cost-center',
      }];

      if (this.swMaintenanceScheduling) {
        actions.push({
          label: 'Captura horas/día',
          icon: 'pi pi-clock',
          action: 'hours-day-capture',
        });
      }
      this.tableActions = actions
    } else {
      this.tableActions = this.getDefaultActions();
    }
  }

  async createMassiveOrder(remissionDetails: RemissionDetailModel[], orderId: number) {
    try {
      await firstValueFrom(this.remissionFromOrderService.createMassiveOrder(remissionDetails, orderId));
      this.toastHandlerService.showToast(
        'success',
        'El detalle de la remisión fue creado exitosamente'
      );
      this.reloadRemissionContract.emit(true);
      await this.getRemissionDetailsByRemission();
    } catch (error) {
      console.error('Error al obtener las columnas para seleccionar el pedido.', error);
    }
  }

  async createRemissionDetails(remissionDetails: RemissionDetailModel[]) {
    try {
      await firstValueFrom(this.remissionDetailService.createRemissionDetails(remissionDetails, this.remissionModel.remissionId));
      this.toastHandlerService.showToast(
        'success',
        'El detalle de la remisión fue creado exitosamente',
      );
      await this.getRemissionDetailsByRemission();
    } catch (error) {
      console.error('Error al obtener las columnas para seleccionar el pedido.', error);
    }
  }

  async processManualOrderSelection(remissionDetails: RemissionDetailModel[]) {
    try {
      await firstValueFrom(this.remissionFromOrderService.processManualOrder(remissionDetails));
      this.toastHandlerService.showToast(
        'success',
        'El detalle de la remisión fue creado exitosamente',
      );
      this.reloadRemissionContract.emit(true);
      await this.getRemissionDetailsByRemission();
    } catch (error) {
      console.error('Error al procesar la orden manual.', error);
    }
  }

  async deleteRemissionDetail(selectedIds: number[]) {
    if (selectedIds.length === 0) return;
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar el detalle de la remisión?')) {
      try {
        await firstValueFrom(this.remissionDetailService.deleteSomeDetails(selectedIds));
        this.toastHandlerService.showToast(
          'success',
          'El detalle del servicio fue eliminado exitosamente.'
        );
        this.clearSelectionTrigger++;
        await this.getUpdateListDetailByDelete();
        this.getFormOrderView(false);
        this.getFormView(false);
      } catch (error) {
        console.error('Error to delete remission details.', error);
      }
    }
  }

  async editRemissionDetail(id: number) {
    const response = await firstValueFrom(this.remissionDetailService.getRemissionDetailById(id));
    if (response) {
      this.remissionDetail = response;
      this.getFormView(true);
    }
  }

  async getColumns() {
    try {
      this.detailHeader = await firstValueFrom(this.remissionDetailService.getColumnsForCaptureTable());
    } catch (error) {
      console.error('Error searching columns for query.', error);
    }
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticle.length != 0) return;
      this.headerArticle = await firstValueFrom(this.remissionDetailService.getColumnsForListStocksInShop());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  getCostCenterPriceRegister(costCenterPrice: CostCenterPriceModel) {
    if (costCenterPrice.costCenterPriceId != 0) {
      if (this.openFromCostCenterPrice == "createRemissionDetail") {
        this.costCenterPriceContract = costCenterPrice;
      } else if (this.openFromCostCenterPrice == "editRemissionDetail") {
        this.getRemissionDetailsByRemission();
      }
    }
  }

  getCostCenterPriceOpen(costCenterPrice: CostCenterPriceModel) {
    this.openFromCostCenterPrice = "createRemissionDetail";
    this.costCenterPriceContract = costCenterPrice;
    this.openCostCenterPriceRegisterModal();
  }

  getDefaultActions(): TableAction[] {
    const actions = [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      },
      {
        label: 'Editar Precios C.Costos',
        icon: 'pi pi-dollar',
        action: 'prices-cost-center',
      },
    ];

    if (this.swMaintenanceScheduling) {
      actions.push({
        label: 'Captura horas/día',
        icon: 'pi pi-clock',
        action: 'hours-day-capture',
      });
    }

    return actions
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
    this.isFormOrderView = false;
    this.updateFormTitle();
  }

  getFormOrderView(isFormOrderView: boolean) {
    this.isFormOrderView = isFormOrderView;
    this.isFormView = false;
    this.updateFormTitle();
  }

  async getGeneralParametersByCompany() {
    const load = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swOrderModule = response.some(x => x.name === GeneralParameters.orderModule);
      this.swReservation = response.some(x => x.name === GeneralParameters.swReservation);
      this.swMaintenanceScheduling = response.some(x => x.name === GeneralParameters.maintenanceScheduling);
      const swEquipmentDispatchWithoutOrder = response.some(x => x.name === GeneralParameters.equipmentDispatchWithoutOrder);
      const swAccessoryDispatchWithoutOrder = response.some(x => x.name === GeneralParameters.accessoryDispatchWithoutOrder);
      this.swDispatchEnabled = swEquipmentDispatchWithoutOrder || swAccessoryDispatchWithoutOrder;
      this.changeDisabled(this.disabledDetail);
    });
    this.listObservers.push(load);
  }

  async getListArticlesStocksInShop() {
    try {
      this.dataArticle = await firstValueFrom(this.remissionDetailService.getListArticlesStocksInShop(
        this.remissionModel.remissionId, this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getRemissionDetailByKeys(storeId: number, articleId: number): Promise<RemissionDetailModel> {
    try {
      const response = await firstValueFrom(
        this.remissionDetailService.getRemissionDetailByKeys(this.remissionModel.remissionId, storeId, articleId)
      );
      this.getFormView(true);
      return response;
    } catch (error) {
      console.error('Error al obtener el detalle por claves.', error);
      return new RemissionDetailModel();
    }
  }

  async getRemissionDetailByOrderKeys(storeId: number, articleId: number, orderDetailId: number): Promise<RemissionDetailFromOrderModel> {
    try {
      const remissionId = this.remissionModel.remissionId;
      const response = await firstValueFrom(this.remissionFromOrderService.getRemissionDetailByOrderKeys(
        remissionId, storeId, articleId, orderDetailId
      ));
      this.getFormOrderView(true);
      return response;
    } catch (error) {
      console.error('Error al obtener el detalle por claves.', error);
      return new RemissionDetailFromOrderModel();
    }
  }

  async getRemissionDetailById(remissionDetailId: number) {
    try {
      this.remissionDetail = await firstValueFrom(this.remissionDetailService.getRemissionDetailById(remissionDetailId));
    } catch (error) {
      console.error('Error al obtener el detalle de la remisión por Id.', error);
    }
  }

  async getRemissionFromOrderDetailById(remissionId: number, remissionDetailId: number, articleId: number) {
    try {
      this.remissionDetailFromOrder = await firstValueFrom(this.remissionFromOrderService.getRemissionFromOrderDetailById(remissionId,
        remissionDetailId, articleId));
      this.getFormOrderView(true);
    } catch (error) {
      console.error('Error al obtener el detalle de la remisión desde el pedido por Id.', error);
    }
  }

  async getRemissionDetailsByRemission() {
    try {
      let remissionDetail = new PagedResponseModel<RemissionDetailRegisterModel>();
      if (this.remissionModel.remissionId != 0) {
        remissionDetail = await firstValueFrom(this.remissionDetailService.getRemissionDetailsForCaptureTable(this.page, this.limit,
          this.columnSort, this.ascendant, this.remissionModel.remissionId));
      }
      this.detailData = remissionDetail;
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error al obtener los detalles de la remission.', error);
    }
  }

  async getUpdateListDetailByDelete() {
    this.remissionDetail = new RemissionDetailModel();
    await this.getRemissionDetailsByRemission();
  }

  async handleManualOrderSelection(selectedItem: any) {
    if (selectedItem.length == 1) {
      const [{ storeId, articleId, orderDetailId, quantityRemission }] = selectedItem;
      const response = await this.getRemissionDetailByOrderKeys(storeId, articleId, orderDetailId);
      response.storeId = storeId;
      response.articleId = articleId;
      response.quantity = quantityRemission ?? 0;
      this.remissionDetailFromOrder = response;
      if (orderDetailId && this.swOrderModule) {
        response.orderDetailId = orderDetailId;
      }
    } else {
      const remissionDetails = selectedItem.map((element: {
        storeId: number,
        articleId: number,
        orderDetailId: number | null,
        quantityRemission: number | null
      }) => {
        const newRemissionDetail = new RemissionDetailModel();
        newRemissionDetail.remissionId = this.remissionModel.remissionId;
        newRemissionDetail.articleId = element.articleId;
        newRemissionDetail.storeId = element.storeId;
        newRemissionDetail.quantity = element.quantityRemission ?? 0;
        if (element.orderDetailId && this.swOrderModule) {
          newRemissionDetail.orderDetailId = element.orderDetailId;
        }
        return newRemissionDetail;
      });

      await this.processManualOrderSelection(remissionDetails);
    }
  }

  async handleMassiveOrderSelection(selectedItems: MassiveOrderDetailSelectionTable[]) {
    if (!selectedItems?.length) return;
    const orderId = selectedItems[0].orderId;
    const newDetails = selectedItems.map((item: MassiveOrderDetailSelectionTable) => {
      const detail: RemissionDetailModel = new RemissionDetailModel();
      detail.remissionId = this.remissionModel.remissionId;
      detail.storeId = item.storeId;
      detail.articleId = item.articleId;
      detail.orderDetailId = item.orderDetailId;
      return detail;
    });

    await this.createMassiveOrder(newDetails, orderId);
  }

  async handleArticleSelectionAsync(selectedItem: any) {
    if (selectedItem.length == 1) {
      const articleId = parseInt(selectedItem[0]?.articleId);
      const storeId = parseInt(selectedItem[0]?.storeId);
      const response = await this.getRemissionDetailByKeys(storeId, articleId);
      if (response.remissionDetailId === 0) {
        this.remissionDetail = new RemissionDetailModel();
        this.remissionDetail.articleId = articleId;
        this.remissionDetail.storeId = storeId;
      } else {
        this.remissionDetail = response;
      }
    } else {
      const remissionDetails: RemissionDetailModel[] = []
      selectedItem.forEach((element: { articleId: number; storeId: number; }) => {
        const newRemissionDetail = new RemissionDetailModel();
        newRemissionDetail.remissionId = this.remissionModel.remissionId;
        newRemissionDetail.articleId = element.articleId;
        newRemissionDetail.storeId = element.storeId;
        remissionDetails.push(newRemissionDetail);
      });

      await this.createRemissionDetails(remissionDetails);
    }
  }

  isButtonDisabled(): boolean {
    const isNewRemission = this.remissionModel.remissionId === 0;
    return (this.swDispatchEnabled && isNewRemission) || this.disabledDetail;
  }

  async onAction(event: { action: string, item?: RemissionDetailRegisterModel, selectedItems?: number[] }) {
    switch (event.action) {
      case 'edit': {
        if (event.item!.orderId && this.swOrderModule) {
          await this.getRemissionFromOrderDetailById(event.item!.remissionId, event.item!.remissionDetailId,
            event.item!.articleId);
        } else {
          await this.editRemissionDetail(event.item!.id);
        }
        break;
      }
      case 'prices-cost-center': {
        await this.prepareCostCenterPrice(event.item!.id);
        break;
      }
      case 'bulk-delete': {
        if (event.selectedItems) {
          this.deleteRemissionDetail(event.selectedItems);
        }
        break;
      }
      case 'hours-day-capture': {
        await this.openCaptureHoursDaysModal(event.item!.id);
        break;
      }
    }
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getListArticlesStocksInShop()]
    );
    this.updateInputs();
    this.articleSelectionModalComponent?.show();
  }

  openCostCenterPriceRegisterModal() {
    this.inputsForRegisterModals$.next({
      costCenterPriceModel: this.costCenterPriceContract,
      openFrom: this.openFromCostCenterPrice,
      blockForm: this.disabledDetail,
    });
    this.costCenterPriceRegisterComponent?.show();
  }

  openManualOrderSelectionModal() {
    this.inputsForManualOrderSelectionModals$.next({
      remissionModel: this.remissionModel
    });
    this.manualOrderSelectionModalComponent?.show();
  }

  openMassiveOrderSelectionModal() {
    if (this.swReservation) {
      this.toastHandlerService.showToast(
        'info',
        'Esta función no está disponible mientras la configuración de reservas esté activa para la compañía.'
      );
      return;
    }
    this.inputsForMassiveOrderSelectionModals$.next({
      remissionId: this.remissionModel.remissionId
    });
    this.massiveOrderSelectionModalComponent?.show();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getRemissionDetailsByRemission();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getListArticlesStocksInShop();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async openCaptureHoursDaysModal(id: number) {
    const remissionDetail = await firstValueFrom(this.remissionDetailService.getRemissionDetailById(id));
    if (remissionDetail.remissionDetailId == 0) return;

    if (!remissionDetail.article?.swEquipmentLogbook) {
      this.toastHandlerService.showToast(
        'warning',
        'Solo se pueden ingresar horas de uso a los equipos electromecánicos.'
      );
      return;
    }

    this.inputsForCaptureHoursDaysModals$.next({
      remissionContract: this.remissionModel,
      remissionDetailContract: remissionDetail
    });
    this.captureHoursDaysComponent?.show();
  }

  async prepareCostCenterPrice(id: number) {
    const remissionDetail = await firstValueFrom(this.remissionDetailService.getRemissionDetailById(id));
    if (!remissionDetail?.costCenterPrice) return;
    if (remissionDetail.orderDetailId != null) {
      this.toastHandlerService.showToast(
        'error',
        'No es posible modificar, el artículo viene de un pedido.'
      );
      return;
    }

    this.costCenterPriceContract = new CostCenterPriceModel();
    this.costCenterPriceContract.costCenterId = remissionDetail.costCenterPrice.costCenterId;
    this.costCenterPriceContract.conceptInvoicingId = remissionDetail.costCenterPrice.conceptInvoicingId;
    this.costCenterPriceContract.articleId = remissionDetail.costCenterPrice.articleId;
    this.openFromCostCenterPrice = "editRemissionDetail";
    this.openCostCenterPriceRegisterModal();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  reloadRemission(reloadRemissionContract: boolean) {
    this.reloadRemissionContract.emit(reloadRemissionContract);
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  updateFormTitle() {
    const titles: Record<string, string> = {
      normal: this.swOrderModule ? 'Registrar detalle de remisión sin pedido' : 'Registrar detalle de remisión',
      order: 'Registrar detalle de remisión – Pedido (Manual)',
      default: 'Detalle de remisión'
    };
    const state = this.isFormView ? 'normal' : this.isFormOrderView ? 'order' : 'default';
    this.formTitle = titles[state];
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }
}
